import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './vault.css';

const ecwidAppId = import.meta.env.VITE_ECWID_APP_ID || 'backuply';
const rootEl = document.getElementById('root');
const inIframe = window.self !== window.top;

if (rootEl) {
  rootEl.setAttribute('data-ecwid-app-id', ecwidAppId);
}

if (inIframe) {
  document.documentElement.classList.add('ecwid-iframe');
  document.body.classList.add('ecwid-iframe');
  if (rootEl) rootEl.classList.add('ecwid-iframe');
  if (typeof EcwidApp !== 'undefined') {
    EcwidApp.init({
      app_id: ecwidAppId,
      autoloadedflag: true,
      autoheight: true,
    });
  }
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
